import React from 'react';
import { Link } from 'react-router-dom';

const ApiCallForm = ({
  isLoadingApiCalls,
  apiCallsError,
  availableApiCalls,
  selectedApiCallId,
  setSelectedApiCallId,
  handleSaveApiCall,
  editingApiCallIndex,
  setApiCall,
  setEditingApiCallIndex
}) => {
  return (
    <div>
      <div className="mb-3">
        <label className="block text-xs font-medium text-gray-500 mb-1">
          Select API Call
        </label>
        {isLoadingApiCalls ? (
          <div className="py-2 text-sm text-gray-500">Loading API calls...</div>
        ) : apiCallsError ? (
          <div className="py-2 text-sm text-red-500">{apiCallsError}</div>
        ) : availableApiCalls.length === 0 ? (
          <div className="py-2 text-sm text-gray-500">
            No API calls available. 
            <Link to="/api-calls/create" className="ml-1 text-blue-600 hover:underline">
              Create one first
            </Link>
          </div>
        ) : (
          <select
            value={selectedApiCallId}
            onChange={(e) => setSelectedApiCallId(e.target.value)}
            className="w-full p-2 rounded border border-gray-300 focus:border-black focus:outline-none"
          >
            <option value="">-- Select an API call --</option>
            {availableApiCalls.map(call => (
              <option key={call.id} value={call.id}>
                {call.name} ({call.method} {call.url})
              </option>
            ))}
          </select>
        )}
      </div>
      
      <button
        type="button"
        onClick={handleSaveApiCall}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors mb-2"
        disabled={!selectedApiCallId || isLoadingApiCalls}
      >
        {editingApiCallIndex !== undefined ? 'Update API Call' : 'Add API Call'}
      </button>
      
      {editingApiCallIndex !== undefined && (
        <button
          type="button"
          onClick={() => {
            setApiCall({
              name: '',
              method: 'GET',
              url: '',
              body: ''
            });
            setSelectedApiCallId('');
            setEditingApiCallIndex(undefined);
          }}
          className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded transition-colors"
        >
          Cancel Edit
        </button>
      )}
    </div>
  );
};

export default ApiCallForm; 